import { useSubscribeCommandsWithRegistry } from '@atlassian/jira-command-palette/src/controllers/use-subscribe-commands/index.tsx';
import type { COMMAND_PALETTE_REGISTRY_ID } from '../../common/constants/registry/index.tsx';

export const useSubscribeCommands = useSubscribeCommandsWithRegistry<COMMAND_PALETTE_REGISTRY_ID>;
